import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "reactstrap";
import { Link } from "react-router-dom";
import ImgLogo from "assets/images/footer-logo.png";
import Instagram from "assets/images/insta.svg";
import Facebook from "assets/images/face.svg";
import Twitter from "assets/images/twitter.svg";
import imgLocation from "assets/images/location.svg";
import imgCall from "assets/images/call.svg";
import imgEmail from "assets/images/email.svg";
import { useTranslation, withTranslation } from "react-i18next";

import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { authenticate } from "store/Auth/actions";
import UnitTypesService from "services/Admin/UnitTypesService";
import AreasService from "services/Admin/AreasService";
import { appendFilters } from "store/actions";

function Footer(props) {
	const { t, i18n } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const lang = useSelector((state) => state.Auth?.lang);
	const dispatch = useDispatch();
	const filterData = useSelector((state) => state.filter);
	const unitTypesService = new UnitTypesService();
	const areasService = new AreasService();
	const [locationOptions, setLocationOptions] = useState([]);
	const [unitTypeOptions, setUnitTypeOptions] = useState([]);

	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			props?.history.push(`/profile/interests`);
		} else {
			dispatch(authenticate({ navigateTo: `/profile/interests` }));
			props?.history.push(`/login`, {
				navigateTo: `/profile/interests`,
			});
		}
	};
	const getSelectData = (service, setData) => {
		service.getFooterData().then((res) => {
			const data = res.data.map((item) => {
				return {
					name: item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setData(data);
		});
	};

	useEffect(() => {
		getSelectData(unitTypesService, setUnitTypeOptions);
		getSelectData(areasService, setLocationOptions);
	}, []);

	return (
		<div className="container-fluid p-0">
			<footer className="footerBuyer">
				<Container fluid className="px-lg-5 pt-lg-4">
					<Row className="footer-container pb-3 px-3 pt-1">
						<Col lg={3} md={6} sm={6} xs={6} className="dummy-text">
							<div className="pt-lg-4">
								<img src={ImgLogo} className="img-fluid" alt="logo-icon" />
								{/* <p className="text-white opacity-100 pt-3">
									Real Estate Company
								</p>
								 */}
							</div>
						</Col>
						<Col
							lg={2}
							md={3}
							sm={6}
							xs={6}
							className="dummy-text text-start text-md-center">
							<div className="linksFooter">
								<h6>{t("Site Map")}</h6>
								<p>
									<Link to="/resales">{t("Resale")}</Link>
								</p>
								<p>
									<Link to="/">{t("Buy")}</Link>
								</p>
								<p>
									<Link to="/about-us">{t("About Us")}</Link>
								</p>
								<p>
									<Link to="" onClick={() => checkAuth()}>
										{t("Wishlist")}
									</Link>
								</p>
								<p>
									<Link to={{ pathname: `/login`, state: "signup" }}>
										{t("Register")}
									</Link>
								</p>
							</div>
						</Col>
						<Col
							lg={2}
							md={3}
							xs={6}
							className="dummy-text text-start text-md-center">
							<div className="linksFooter">
								<h6>{t("Properties")}</h6>
								{unitTypeOptions?.map((unitOption, index) => {
									return (
										<p className="select" key={index}>
											<Link
												to="/resales"
												onClick={() => {
													dispatch(
														appendFilters({
															unitType: [unitOption],
														})
													);
												}}>
												{unitOption?.name[lang]}
											</Link>
										</p>
									);
								})}
							</div>
						</Col>
						<Col
							lg={2}
							md={4}
							xs={6}
							className="dummy-text text-start text-md-center">
							<div className="linksFooter">
								<h6>{t("Top Area")}</h6>
								{locationOptions?.map((location, index) => {
									return (
										<p className="select" key={index}>
											<Link
												to="/resales"
												onClick={() => {
													dispatch(appendFilters({ ResaleLocation: location }));
												}}>
												{location?.name[lang]}
											</Link>
										</p>
									);
								})}
							</div>
						</Col>
						<Col
							lg={3}
							md={8}
							xs={12}
							className="dummy-text text-start text-md-center">
							<div className="linksFooter">
								<h6>{t("Footer Contact Information")}</h6>
								<p>
									<img src={imgLocation} className="me-2" alt="" /> Floor 3, El
									Aykona building, 16 Mohamed Sakep EL zamalek, Cairo
								</p>
								<p>
									<a href="mailto:Info@sakneen.com">
										<img src={imgEmail} className="me-2" alt="" />{" "}
										Info@sakneen.com
									</a>
								</p>
								<p>
									<a href="tel:1992">
										<img src={imgCall} className="me-2" alt="" />
										1992{" "}
									</a>
								</p>
							</div>
						</Col>
					</Row>
				</Container>

				<div className="d-flex pb-3  px-3  justify-content-end gap-2">
					<Link to="/">
						<img src={Facebook} className="img-fluid me-2" />
					</Link>
					<Link to="/">
						<img src={Instagram} className="img-fluid me-2" />
					</Link>
					<Link to="/">
						<img src={Twitter} className="img-fluid me-2" />
					</Link>
				</div>
			</footer>
		</div>
	);
}
export default withRouter(withTranslation()(Footer));
